import { CompanyCreationForm } from 'components/Pages/Companies';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const CompanyCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/configuracoes/clientes');
  }, [navigate]);

  return (
    <Scaffold>
      <CompanyCreationForm onCreate={onCreate} />
    </Scaffold>
  );
};
